// hooks/useUserData.js - Simple hook to get decrypted session data
import { useState, useEffect } from "react";
import { getUserData, storeUserData } from "../services/apiService";
import { hydrateOrgModulesIfMissing } from "../services/orgModulesHydrationService";
import { getLoginModuleRows } from "../utils/loginModulesUtils";

export const useUserData = () => {
  const [userData, setUserData] = useState(() => getUserData());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const loadUserData = async () => {
      try {
        let data = getUserData();
        if (data) {
          data = await hydrateOrgModulesIfMissing(data);
          const rows = getLoginModuleRows(data);
          if (
            !cancelled &&
            rows !== null &&
            rows.length > 0 &&
            !getLoginModuleRows(getUserData())?.length
          ) {
            storeUserData(data);
          }
        }
        if (!cancelled) {
          setUserData(data);
        }
      } catch (error) {
        console.error("Error loading user data:", error);
        if (!cancelled) {
          setUserData(null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadUserData();

    return () => {
      cancelled = true;
    };
  }, []);

  // Refresh function to reload user data
  const refreshUserData = () => {
    const data = getUserData();
    setUserData(data);
    return data;
  };

  return {
    userData, // Complete decrypted user object from API
    loading, // Boolean: is data still loading?
    refreshUserData, // Function: refresh the data
    isLoggedIn: !!userData, // Boolean: is user logged in?
  };
};

export default useUserData;
